import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=6a2d4997&scoped=true"
import script from "./Compass.vue?vue&type=script&lang=js"
export * from "./Compass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d4997",
  null
  
)

export default component.exports